<style>
 #adminImport tr td:last-child {
    width: 300px !important;
    background-color: transparent;    
    word-wrap: break-word !important;
    white-space: pre-wrap !important;   
    overflow: scroll !important;
}
</style>

<section>
  <div class="container-fluid">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Home</li>
      <li class="breadcrumb-item">Vendors</li>
      <li class="breadcrumb-item active">Import Invoice Applicant</li>
    </ol>
  </div>
</section>
<section>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12 p-0">
        <div class="card Title-bar-blue">
          <div class="devcare-card-header">
            <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i>Import Invoice
              Applicant</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="row">
    <div class="col-md-4">
    </div>
    <div class="col-md-4">
      <div class="card">
        <div class="card-header" style="background-color: #ecf0f5">
          <div class="p-text-bold">
            File Upload<span class="required-field">*</span>
          </div>
        </div>
        <div class="card-body">
          <div class="p-mt-2 p-mb-2">
            <div class="text-center">
              <span>The import file should contain the predefined fields</span><br />
              <span><a (click)="downloadSampleFile()" [routerLink]="">
                  <i class="pi pi-download"></i> Click here to download the
                  sample template</a></span>
            </div>
          </div>
          <br>
          <form [formGroup]="importInvoiceApplicantForm">
            <div class="vms-file-upload">
              <input type="file" id="timesheetUpload" accept=".xls,.xlsx" multiple="false" formControlName="file"
                #fileUpload (change)="onImportInvoiceSelect($event)" (click)="$event.target.value = null"
                style="display: none" />
                <div class="text-center p-mb-3">
                  <button pButton pRipple type="button" label="Choose File" [disabled]="disableImportBtn"
                  class="p-button-outlined p-button-sm input-btn" (click)="fileUpload.click()"></button>
                </div>
              <div class="p-d-flex p-jc-between">
                <div>                 
                  <button pButton pRipple type="button" label="Upload" icon="pi pi-upload"
                    class="p-button-sm p-button-raised p-button-success p-ml-2" [style]="{'width':'104.71px'}" (click)="save()" [loading]="loading"
                    [disabled]="
                      !importInvoiceApplicantForm.valid || disableImportBtn"></button>
                </div>
                <div>
                  <button pButton pRipple type="button" label="Clear" icon="pi pi-times"
                    class="p-button-sm p-button-raised p-button-danger p-ml-2" [style]="{'width':'104.71px'}" (click)="cancel()"></button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <span>{{ uploadedFileName }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4">
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">

    </div>
  </div>
  
</section>

<section class="invoice-import" *ngIf="isShowInputTable">
  <div class="row">
    <div class="col-md-12">
      <div class="card invoice-Applicants">
        <div class="card-header">
          <span class="card-title invoiceApplicants-header">Uploaded Records</span>
          <div class="card-tools">
            <p-multiSelect [options]="invoiceApplicantAllColumns" [(ngModel)]="invoiceApplicantSelectedColumns"
              maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected"
              optionLabel="header" [showHeader]="false"  style="float: right;">
              <ng-template let-column pTemplate="item">
                <div class="column-item">
                  <div>{{column.header}}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="card-body">
          <p-table id="adminImport" [value]="invoiceApplicants" [columns]="invoiceApplicantSelectedColumns"
            styleClass="p-datatable-gridlines" [resizableColumns]="true" columnResizeMode="expand">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pResizableColumn [style.width]="col.width" *ngFor="let col of columns">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-applicant let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  {{applicant[col.value]}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="18">No Data found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="isValidateTable" class="invoice-import">
  <div class="row">
    <div class="col-md-12">
      <div class="card processed-Applicants">
        <div class="card-header">
          <span class=" card-title validatedInvoiceApplicants-header">Validated Records</span>
          <div class="card-tools">
            <p-multiSelect [options]="validatedInvoiceApplicantAllColumns"
              [(ngModel)]="validatedInvoiceApplicantSelectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list"
              selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader]="false" 
              style="float: right;">
              <ng-template let-column pTemplate="item">
                <div class="column-item">
                  <div>{{column.header}}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="card-body">
          <p-table id="adminImport" [value]="validatedApplicants" styleClass="p-datatable-gridlines"
            [columns]="validatedInvoiceApplicantSelectedColumns" [resizableColumns]="true" columnResizeMode="expand">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pResizableColumn [style.width]="col.width" *ngFor="let col of columns">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-applicant let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  {{applicant[col.value]}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No Data found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="isShowResultTable" class="invoice-import">
  <div class="row">
    <div class="col-md-12">
      <div class="card processed-Applicants">
        <div class="card-header">
          <span class=" card-title processed-InvoiceApplicants-header">Processed Records</span>
          <div class="card-tools">
            <p-multiSelect [options]="processedInvoiceApplicantAllColumns"
              [(ngModel)]="processedInvoiceApplicantSelectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list"
              selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader]="false" 
              style="float: right;">
              <ng-template let-column pTemplate="item">
                <div class="column-item">
                  <div>{{column.header}}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="card-body">
          <p-table id="adminImport" [value]="processedApplicants" styleClass="p-datatable-gridlines"
            [columns]="processedInvoiceApplicantSelectedColumns" [resizableColumns]="true" columnResizeMode="expand">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pResizableColumn [style.width]="col.width" *ngFor="let col of columns">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-applicant let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  {{applicant[col.value]}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No Data found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="isShowResultTable" class="invoice-import">
  <div class="row">
    <div class="col-md-12">
      <div class="card rejected-Applicants">
        <div class="card-header">
          <span class=" card-title rejected-InvoiceApplicants-header">Unprocessed Records</span>
          <div class="card-tools">
            <button pButton  *ngIf="sharedService.checkPermission('Admin_Export')" label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button"
              style="height: 30px;" (click)="exportexcel()"></button>
            <p-multiSelect [options]="rejectedInvoiceApplicantAllColumns"
              [(ngModel)]="rejectedInvoiceApplicantSelectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list"
              selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader]="false" 
              style="float: right;">
              <ng-template let-column pTemplate="item">
                <div class="column-item">
                  <div>{{column.header}}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="card-body">
          <p-table id="adminImport" [value]="rejectedApplicants" styleClass="p-datatable-gridlines" [resizableColumns]="true"
            [columns]="rejectedInvoiceApplicantSelectedColumns" columnResizeMode="expand">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pResizableColumn [style.width]="col.width" *ngFor="let col of columns">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-applicant let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  {{applicant[col.value]}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No Data found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</section>
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">

</p-confirmDialog>
<p-toast position="bottom-center"></p-toast>

<p-dialog header="Import Error" [(visible)]="displayErrorModal" [modal]="true" [style]="{ width: '25vw' }" [draggable]="false"
  [resizable]="false">
  <p class="text-center p-mt-6" style="color: red;">The uploaded file contains invalid/missing data</p>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="displayErrorModal = false" label="Ok" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>